const messages = {
    /* Таблицы */
    dataIterator: {
        rowsPerPageText: "Записи на страница:",
        rowsPerPageAll: "Всичко",
        pageText: "{0}-{1} из {2}",
        noResultsText: "Няма намерени съответстващи записи",
        nextPage: "Следваща страница",
        prevPage: "Предишна страница"
    },
    dataTable: {
        rowsPerPageText: "Редове на страница:"
    },
    noDataText: "Липсва информация",
    carousel: {
        prev: "Предишно изображение",
        next: "Следващо изображение"
    },

    errors: {
        accountConfirmationError: "Неуспешна проверка на акаунта",
        cantUpdateUsersSettings: "Неуспешно актуализиране на потребителските настройки",
        emptyPatterns: "Проверете параметрите на дървения материал, както и наличието на избрани секции",
        errorMethod: "Методът за изчисляване на обема на регистрационния файл не е зададен",
        fbsDiamMaxLog: "(Чип машина) Превишен е максималният диаметър на трупа",
        noConfirmationCodeError: "Кодът за потвърждение не е намерен. Вашият акаунт може вече да е активиран.",
        noOptimalPattern: "В резултат на изчисленията не бяха намерени оптималните настройки. Проверете параметрите на оборудването, дървения материал и трупите, след което повторете изчислението",
        noSawDevices: "На производствената линия няма оборудване за рязане",
        serverConnectionError: "Грешка при свързване със сървъра. Моля, опитайте отново по-късно",
        volumeTableDataNotFound: "В таблицата с обеми няма данни за дадените стойности на диаметър и дължина"
    },

    monthsList: {
        january:   "Януари",
        february:  "Февруари",
        march:     "Март",
        april:     "Април",
        may:       "Може",
        june:      "Юни",
        july:      "Юли",
        august:    "Август",
        september: "Септември",
        october:   "Октомври",
        november:  "Ноември",
        december:  "Декември"
    },

    lineTemplates: {
        cant: "Бар",
        liveCut: "Колапс",
        multiSawsFrame: "Мулти трион рамка",
        profilingLine: "Фрезоване и профилиране",
        chipperCanter: "Чипване-чипер",
        scandinavian: "Скандинавска схема",
        torsion: "Усукване",
        bandLine: "Лентова дъскорезница"
    },

    volumeCalcMethods: {
        topDiamAvgRise: "Горен диаметър и среден ход",
        truncatedCone: "Пресечен конус",
        endSections: "Крайни секции",
        standardTables: "Според таблиците на ГОСТ"
    },

    gosStandards: {
        gost2708_75: "ГОСТ 2708-75",
        gost_r54365_2011: "ГОСТ Р54365-2011",
        gost2708_75Short: "ГОСТ 2708-75",
        gost_r54365_2011Short: "ГОСТ Р54365-2011"
    },

    notes: {
        trialAvailability: "Пробната версия е достъпна веднага след регистрация",
        successApplicationSubmition: "Благодарим ви, вашата кандидатура е приета! Ние ще се свържем с вас скоро.",
        liveCutLine: "Тази линия е стандартна. Възможно е да се променят параметрите на многорезната машина. Добавянето/премахването на оборудване е забранено."
    },

    subscriptionPlans: {
        title: "Тарифни планове и цени",
        currency: "₽",
        quarterly: "за 3 месеца",
        yearly: "за година",
        threeYear: "3 години",
        free: "Уводна",
        standard: "Стандартен",
        professional: "Професионален",
        availableFeatures: "Налични функции",
        restrictions: "Ограничения",
        usersAmount: "Брой потребители",
        patternsAmount: "Броят резултати, налични за съхранение в библиотеката с настройки",
        modelsAmount: "Брой модели на трупи, налични за съхранение",
        sawProfilesAmount: "Брой хардуерни профили",
        features: [
            "Редактиране на справочници за дървен материал, дължини, цена на суровини и продукти",
            "Оптимизиране на обемния добив, като се вземат предвид номиналните размери и размерите на триона",
            "Оптимизиране на цената, като се вземе предвид зависимостта на цената от напречното сечение, дължината на дървения материал, както и цената на чипс и дървени стърготини",
            "Възможност за създаване на индивидуална дъскорезна линия",
            "Оптимизация, като се вземе предвид подрязването на ръбовете (разтваряне на необрязана дъска на няколко кантирани дъски), възможност за рязане на централния комплект",
            "Отпечатване на отчета за оптимизация и запазване на резултата в библиотеката",
            "Преглед на 3D модели на стълбове и трупи",
            "Ръчно създаване и редактиране на настройки",
            "Избор на оптимален диаметър за стойката и диапазон от диаметри за ефективно рязане",
            "Експорт и импорт на резултати от оптимизация",
            "Оптимизация за кривина на трупа",
            "Оптимизация, като се вземе предвид елипсата на дневника",
            "Изчисление, като се вземе предвид допустимото отклонение и платката без сърцевина",
            "Интеграция с други фирмени продукти \"AVTOMATIKA-VEKTOR\""
        ],
    },

    /* Модули */
    calc: "Оптимизация",
    general: "Система",
    lines: "Линии",

    appName: "SawsOptimization WEB",
    avtomatikaVektor: "AVTOMATIKA-VEKTOR",

    acceptCookies:"Приеми и затвори",
    acceptLicense: "Приемам лицензионното споразумение",
    accessControl: "Контрол на достъпа",
    accessDenied: "Достъпът е отказан",
    accountConfirmed: "Акаунтът е потвърден",
    aclCreate: "Създаване",
    aclDelete: "Удаление",
    aclExport: "Експортиране",
    aclModify: "Промяна",
    aclRead: "Четене",
    aclUpdated: "Списъкът за контрол на достъпа е актуализиран",
    action: "Действие",
    actualSizes: "остриета за триони",
    addLineTemplate: "Създайте линия от шаблон",
    address: "Адрес",
    administration: "Администрация",
    administrator: "Администратор",
    all: "Всичко",
    alongCurvature: "По кривината",
    amount: "Количество",
    amountShort: "Кол-во",
    and: "и",
    applicationError: "Грешка в приложението",
    apply: "Приложи",
    archived: "Архив",
    aspen: "Аспен",
    asymmetric: "Асиметрична",
    attention: "Внимание!",
    atTheButt: "В дупето",
    atTheTop: "На върха",
    authorization: "Упълномощаване",
    auto: "Автоматичен",
    automaticallyCalculateTaper: "Изчислете конусность автоматично",
    averageTaper: "Среден конусность",
    avgCurv: "Сред. крив.",
    avgCurvature: "Сред. кривина",
    batchOfLogs: "Партида трупи",
    bandSaw: "Банциг",
    bandSawShort: "Банциг",
    bark: "Кора",
    birch: "Бреза",
    boards: "Дъски",
    boardsCuttingPossibility: "Възможност за разтваряне на дъски",
    boardsParameters: "Параметри на дъските",
    boardsVolume: "Обем на дъските",
    boardsV: "V дъс.",
    boardType: "Тип дъска",
    bottom: "Комел",
    byCantWidth: "По ширина на лъча",
    byPrice: "По цена",
    byVolume: "По обем",
    calculate: "Изчисли",
    calculated: "Изчислено",
    calculatedBoards: "Изчислени дъски",
    calculationError: "Неуспешно изчисляване",
    calculations: "Изчисления",
    cancel: "Отказ",
    cantCreateCompany: "Неуспешно създаване на фирма",
    cantCreateDimension: "Неуспешно създаване на секцията",
    cantCreateLength: "Неуспешно създаване на дължина",
    cantCreateUser: "Неуспешно създаване на потребителски акаунт",
    cantDeleteCompany: "Неуспешно изтриване на фирма",
    cantDeleteDimension: "Неуспешно изтриване на секцията",
    cantDeleteLength: "Премахването на дължината не бе успешно",
    cantDeleteLumber: "Не може да се премахне дървен материал",
    cantDeleteLumberGroup: "Неуспешно изтриване на група дървен материал",
    cantDeleteModel: "Неуспешно изтриване на модела",
    cantDeletePattern: "Неуспешно изтриване на постав",
    cantDeletePrice: "Неуспешно изтриване на цената",
    cantDeleteProfile: "Неуспешно изтриване на профил",
    cantDeleteUser: "Неуспешно изтриване на потребител",
    cantLoad3DModelData: "Неуспешно зареждане на данни за 3D модел",
    cantLoad3DModelsData: "Неуспешно зареждане на данни за 3D модел",
    cantLoadACL: "Неуспешно получаване на списък за контрол на достъпа",
    cantLoadCalcMethodsData: "Неуспешно получаване на списък с методи за изчисление",
    cantLoadCompaniesData: "Неуспешно получаване на фирмени данни",
    cantLoadConfig: "Неуспешно получаване на конфигурация",
    cantLoadData: "Неуспешно получаване на данни",
    cantLoadDimensionsData: "Неуспешно получаване на данни за секциите",
    cantLoadEquipmentData: "Неуспешно получаване на хардуерни данни",
    cantLoadEquipmentProfiles: "Неуспешно получаване на хардуерни профили",
    cantLoadEventsData: "Неуспешно получаване на данни за събитието",
    cantLoadGroupsData: "Неуспешно получаване на групови данни",
    cantLoadLengthsData: "Данните за дължината не бяха получени",
    cantLoadLoginInfo: "Неуспешно получаване на данни за оторизация",
    cantLoadLumberData: "Не могат да се получат данни за дървен материал",
    cantLoadModulesData: "Неуспешно получаване на данни за модула",
    cantLoadPatternsData: "Неуспешно получаване на данни за доставка",
    cantLoadPricesData: "Неуспешно получаване на данни за цените",
    cantLoadProfiles: "Неуспешно получаване на профили",
    cantLoadSettings: "Неуспешно получаване на настройките",
    cantLoadSpeciesData: "Неуспешно получаване на данни за породата",
    cantLoadSubscriptionInfo: "Неуспешно получаване на данни за абонамент",
    cantLoadSystemLog: "Неуспешно получаване на syslog",
    cantLoadTasksData: "Неуспешно получаване на данни за задачата",
    cantLoadUserInfo: "Неуспешно получаване на потребителски данни",
    cantLoadUsersData: "Неуспешно получаване на потребителски данни",
    cantProduction: "Производство на дървен материал",
    cantSaveData: "Неуспешно запазване на данните",
    cantSaveLumberGroup: "Неуспешно запазване на групата дървен материал",
    cantSavePattern: "Запазването на позата не бе успешно",
    cantSaveProfile: "Неуспешно запазване на профила",
    cantScanner: "Скенер за лъчи",
    cantSendMessage: "Неуспешно изпращане на съобщение",
    cantType: "Тип дървен материал",
    cantUpdateACL: "Неуспешно актуализиране на списъка за контрол на достъпа",
    cantUpdateCompany: "Неуспешно актуализиране на фирмените данни",
    cantUpdateData: "Неуспешно актуализиране на данните",
    cantUpdateLength: "Неуспешно актуализиране на дължината",
    cantUpdatePrices: "Неуспешно актуализиране на цените",
    cantUpdateSubscription: "Неуспешно актуализиране на настройките за абонамент",
    cantUpdateUser: "Неуспешно актуализиране на потребителските данни",
    cantUploadFile: "Неуспешно качване на файл",
    cantUploadModel: "Неуспешно зареждане на 3D модел",
    cantUploadPattern: "Неуспешно зареждане на инсталацията",
    captchaAPICallFailed: "Възникна грешка при проверката на CAPTCHA, моля, опитайте отново по-късно",
    captchaCheckNegative: "Не сте преминали проверката CAPTCHA. Вашите действия са много подобни на автоматизираните",
    catalogs: "Справочници",
    cedar: "Кедър",
    centralBoard: "Централна дъска",
    centralBoards: "Централни дъски",
    centralBoardsCutting: "Разпускане на централни дъски",
    centralBoardsMinTotalThickness: "Мин. обща дебелина на центр. дъски",
    centralHalfTimberSawing: "Рязане на централната шейна",
    centralKerf: "Централен разрез",
    circularSaw: "Циркуляр",
    circularSawShort: "Циркуляр",
    clear: "Изчистване",
    clearFormRequest: "Наистина ли искате да изчистите формуляра?",
    clearTheForm: "Изчистване на формата",
    close: "Близо",
    cm: "см",
    cookiesMessageFirstRow: "Този сайт използва cookie!",
    cookiesMessageSecondRow: "Продължавайки да го използвате, вие се съгласявате с използването на cookie.",
    companies: "Производител",
    company: "Производител",
    companyAlreadyRegistered: "Производител с това име вече е регистрирана. За да създадете акаунт, свържете се с неговия администратор",
    companyCreated: "Създаден е нов производител",
    companyDelete: "Премахване на производитела",
    companyName: "Име на производитела",
    companyUpdated: "Данните на производителя са актуализирани",
    confirm3DModelDelete: "Сигурни ли сте, че искате да изтриете 3D модела?",
    confirmationCodeNotFound: "Кодът за потвърждение не е намерен",
    confirmCompanyDelete: "Сигурни ли сте, че искате да премахнете производителя?",
    confirmDimensionDelete: "Сигурни ли сте, че искате да изтриете секцията?",
    confirmLengthDelete: "Сигурни ли сте, че искате да премахнете дължината?",
    confirmLengthGroupDelete: "Сигурни ли сте, че искате да изтриете групата дължина?",
    confirmLumberDelete: "Сигурни ли сте, че искате да премахнете дървения материал?",
    confirmLumberGroupDelete: "Сигурни ли сте, че искате да изтриете групата дървен материал?",
    confirmPatternDelete: "Сигурни ли сте, че искате да премахнете публикацията?",
    confirmPriceDelete: "Сигурни ли сте, че искате да премахнете цената?",
    confirmProfileDelete: "Сигурни ли сте, че искате да изтриете текущия профил?",
    confirmUnsaved: "Има незапазени промени! Сигурни ли сте, че искате да се преместите в друга секция? Това ще доведе до загуба на незапазени данни!",
    confirmUserDelete: "Сигурни ли сте, че искате да изтриете потребителския акаунт?",
    conoidMethod: "Пресечен конус",
    contact: "Контакт",
    contacts: "Информация за връзка",
    copiedToClipboard: "Копирано в клипборда",
    copyToClipboard: "Копиране в клипборда",
    corelessBoard: "Дъска без ядро",
    create: "Създавайте",
    createModifyDate: "Дата на създаване/промяна",
    createPatternsLimitReachedMessage: "Вашият план за фактуриране не ви позволява да създавате повече доставки. Изтрийте старите или преминете към тарифен план с повече функции",
    createUsersLimitReachedMessage: "Вашият план не ви позволява да създавате повече потребители. Изтрийте съществуващите или преминете към план с повече функции",
    currentEdition: "Текущо издание",
    currentPattern: "Актуален модел",
    curvature: "Кривина",
    curvatureCenter: "Център на кривината",
    curvatureSettings: "Опции за кривина",
    cuttingOptimization: "Оптимизация пиления",
    cutWidthAlongTheEdge: "Ширина на рязане на ръба",
    cutWidthAlongThePlate: "Ширина на косене по лицето",
    customer: "Купувач",
    darkTheme: "Тъмна схема",
    dataSaved: "Данните са запазени",
    dataSaveError: "Неуспешно запазване на данните",
    dataUpdated: "Данните са актуализирани",
    date: "Датата",
    dButt: "Диаметър на дупето",
    delete: "Изтрий",
    deleteProfile: "Изтриване на профил",
    denyEdit: "Деактивирайте редактирането",
    denyExport: "Забранете износа",
    denyImport: "Забранете вноса",
    descriptionStepsToReproduce: "Описание на проблема (стъпки за възпроизвеждане)",
    diameter: "Диаметър",
    diameterBottom: "Диаметър на дупето",
    diameterShort: "D.",
    //diametersU: "Диаметры учетные",
    diameterTop: "Горен диаметър",
    diameterU: "Счетоводен диаметър",
    dimension: "Напречно сечение",
    dimensionCreated: "Секцията е създадена",
    dimensionDelete: "Изтриване на раздел",
    dimensionUpdated: "Секцията е актуализирана",
    dimensions: "Раздели",
    distribution: "Разпределение",
    download: "Изтегли",
    dTop: "Горен диаметър",
    dTopShort: "D горен",
    edit: "Редактиране",
    edited: "Редактирано",
    editionFrom: "Редакция от",
    edgeTrimmer: "Кантиращ инструмент",
    edgeTrimmerShort: "Кантиращ инструмент",
    edgeTrimmerUsed: "Използвано оборудване за подрязване на ръбове",
    ellipseRatio: "Елиптичност",
    eMail: "Имейл",
    eMailAddress: "Имейл адрес",
    eMailAddressRejected: "Сървърът не прие посочения от вас адрес, проверете дали не сте въвели грешка",
    eMailIsDisposable: "Не можете да използвате временен имейл адрес за регистрация",
    emptyLineErrorMessage: "Не може да се запише празен ред",
    endSectionMethod: "Крайни секции",
    equipment: "Оборудване",
    equipmentProfile: "Профил на оборудването",
    equipmentProfiles: "Хардуерни профили",
    error: "Грешка",
    errorDuringRequest: "Възникна грешка при изпълнение на заявката",
    even: "Честен",
    executionTime: "Преднина",
    exit: "Изход",
    expenses: "Разноски",
    export: "Експортиране",
    expenditure: "Консумация",
    exportToExternalApp: "Експортиране към външно приложение",
    falseCore: "Фалшиво ядро",
    falseCorePricePrcnt: "Цената на дървен материал с фалшива сърцевина,%",
    fbs: "Чип машина",
    fbsShort: "Чип машина",
    fileName: "Име на файл",
    fileNotSelected: "Файлът не е избран",
    fileParsingError: "Грешка при синтактичния анализ на файла",
    fileTooLarge: "Файлът е твърде голям",
    finalValue: "Крайна стойност",
    findingTheOptimalDiameter: "Намиране на оптималния диаметър",
    fir: "Ела",
    firstName: "Име",
    firstRun: "Първо начало",
    forgotPassword: "Забравих паролата",
    fromTopToButt: "От върха до дупето",
    fullRange: "Пълна гама",
    groupName: "Име на групата",
    groupNameCantBeEmpty: "Името на групата не може да бъде празно",
    halfCant: "Половин лъч",
    hasCalculations: "Има изчисления",
    hasMyCalculations: "Ето моите изчисления",
    help: "Справка",
    history: "История",
    home: "Начална страница",
    horizontalSaw: "Хоризонтален трион",
    horizontalSawShort: "Хориз. трион",
    humidity: "Влажност",
    imageExportCompleted: "Експортирането на изображението завърши",
    import: "Импортиране",
    incorrectEMailOrPassword: "Невалиден и-мейл адрес или парола",
    incorrectValue: "Неправилна стойност",
    information: "Информация",
    initialValue: "Първоначална стойност",
    interface: "Интерфейс",
    invalidEMail: "Грешен имейл адрес",
    kerf: "Пропил",
    kerfExt: "Изрязване външно",
    labeling: "Маркиране",
    language: "Език",
    larch: "Лиственица",
    lastName: "Фамилия",
    lastNews: "Последни новини",
    length: "Дължина",
    lengthGroup: "Група по дължина",
    lengthGroupDelete: "Изтриване на група дължина",
    lengthGroupDeleted: "Групата за дължина е премахната",
    lengthGroupModified: "Групата на дължината е променена",
    lengthGroups: "Групи по дължина",
    lengthGroupSaved: "Групата дължина е запазена",
    lengthCreated: "Създадена дължина",
    lengthDelete: "Премахване на дължина",
    lengthM: "Дължина, m",
    lengths: "Дължини",
    lengthsAndVolumes: "Дължини и обеми",
    lengthUpdated: "Актуализирана дължина",
    libraries: "Библиотеки",
    licenseAgreement: "Лицензионно споразумение",
    lime: "Липа",
    limits: "Ограничения",
    line: "Линия",
    lineChanged: "Променен",
    lineChangedHint: "Има незапазени промени",
    load: "Изтегли",
    loadTesting: "Стрес тестване",
    lock: "Блок",
    lockCoreless: "Заключване на настройките на платката без ядро",
    lockCurvature: "Заключване на настройките за кривина",
    lockWane: "Заключване на настройките за намаляване",
    log: "Дневник",
    logsAmount: "Брой трупи",
    logDimensions: "Размери на трупа",
    logLength: "Дължина на трупа",
    logParameters: "Параметри на дневника",
    logsParameters: "Параметри на трупите",
    logsScanner: "Скенер за трупи",
    logVolume: "Обем на трупите",
    logV: "V тр.",
    lumber: "Дървен материал",
    lumberDelete: "Премахване на дървен материал",
    lumberGroup: "Група дървен материал",
    lumberGroupDelete: "Премахване на група дървен материал",
    lumberGroupDeleted: "Премахната група дървен материал",
    lumberGroupModified: "Променена група диаметри",
    lumberGroups: "Групи дървен материал",
    lumberGroupSaved: "Запазена група дървен материал",
    lumberImport: "Внос на дървен материал",
    m: "м",
    m3: "м3",
    maxAmount: "Максимум",
    maxCantThickness: "Макс. дебелина на гредата",
    maxCurv: "Макс. крив.",
    maxCurvature: "Макс. кривина",
    maxCuttingDepth: "Макс. дълбочина на фрезоване",
    maximalCurvature: "Максимальная кривина",
    maxLines: "Макс. брой хардуерни профили",
    maxModels: "Макс. брой 3D модели",
    maxPatterns: "Макс. брой доставки",
    maxProfilingDepth: "Макс. дълбочина на профилиране",
    maxSawsAmount: "Макс. брой триони",
    maxSideBoardsAmount: "Макс. брой странични дъски от всяка страна",
    maxUsers: "Макс. брой потребители",
    maxWaneLength: "Макс. дължина на отклоняване",
    message: "Съобщение",
    messageSent: "Съобщението е изпратено",
    messageType: "Тип съобщение",
    messageEmptyLengthRange: "Това поле може да се остави празно, в който случай дължините ще бъдат зададени в диапазон въз основа на размерите на трупа",
    //messageTypes: "Типы сообщений",
    middleName: "Презиме",
    minCurv: "Мин. крив.",
    minCurvature: "Мин. кривина",
    minDmm: "Мин. диаметр, мм",
    minimalCurvature: "Минимална кривина",
    minimalLength: "Минимална дължина",
    minTopSideBoardsWidth: "Мин. ширина на бордовите дъски в горната част",
    mm: "мм",
    modelDeleteError: "Грешка. Неуспешно изтриване на модела",
    modelDeleted: "Моделът е изтрит",
    modified: "Променен",
    module: "Модул",
    modules: "Модули",
    ms: "мс",
    multiSaw: "Групов трион",
    multiSawShort: "Групов трион",
    my: "Моя",
    myAccount: "Моята сметка",
    mySubscription: "Моят абонамент",
    name: "Име",
    new: "Нов",
    newGroup: "Нова група",
    newProfile: "Нов профил",
    no: "Не",
    noCurv: "Без крив.",
    noCurvature: "Без кривина",
    noGroup: "Няма група",
    nominalSize: "Номинален размер",
    nominalSizes: "номинален",
    noSpeciesSelectedWarning: "Няма избрани породи! За да разрешите проблема, отидете в ръководството за породата",
    notLoggedIn: "Неоторизиран",
    notUsed: "Не се използва",
    odd: "Странно",
    operator: "Оператор",
    optimalDiameter: "Оптимален диаметър",
    optimalDiametersRange: "Диапазон от оптимални диаметри",
    optimization: "Оптимизация",
    optimizations: "Оптимизации",
    optimizationByWidth: "Оптимизация на ширината",
    optimizationMethod: "Метод за оптимизация",
    optimizerResponseIsNull: "Оптимизаторът не върна резултат",
    output: "Изход",
    outputDeltaForCalculatingOptimalDiamRange: "Делта на добива за изчисляване на оптималния диапазон на диаметъра",
    ok: "ok",
    password: "Парола",
    passwordCantBeEmpty: "Паролата не може да бъде празна",
    passwordChanged: "Паролата е променена успешно",
    passwordChangeError: "Възникна грешка при промяна на паролата",
    passwordConfirm: "Потвърждение на парола",
    passwordReset: "Нулиране на парола",
    passwordResetMessageSent: "На посочения имейл адрес е изпратен имейл с връзка за повторно задаване на парола",
    passwordResetReminder: "За да нулирате паролата си, въведете имейл адреса, който сте посочили по време на регистрацията. Ако сте забравили адреса си, свържете се с вашия системен администратор или поддръжка",
    passwordsMismatch: "Въведените пароли не съвпадат",
    pattern: "Постав",
    patternDeleteError: "Премахването на публикацията не бе успешно",
    patternDeleted: "Постав премахнат",
    patternExportCompleted: "Експортирането на доставката е завършено",
    patternExportError: "Възникна грешка при експортиране на доставката, софтуерът за получаване може да не е наличен в момента, моля, опитайте отново по-късно",
    patternName:"Постав име",
    patterns: "Постави",
    patternSample: "Выкройка сделана",
    patternsLibrary: "Задайте библиотека",
    patternSolidBackground: "Плътен фон при постава",
    patternType: "Тип набор",
    pattern3dView: "3D модел на комплекта",
    pc: "шт",
    period: "месечен цикъл",
    //personalCabinet: "Личный кабинет",
    personalDataAgreement: "Съгласен съм с обработката на личните ми данни",
    phone: "Телефон",
    pine: "Бор",
    price: "Цена",
    priceDelete: "Изтриване на цена",
    prices: "Цени",
    priceM3: "Цена за м3",
    print: "Печат",
    printBatchOfLogs: "Регистрирайте партиден отчет",
    privacyPolicy: "Политика за поверителност",
    profile: "Профил",
    profileDeleted: "Профилът е изтрит",
    profileName: "Профилно име",
    profileNameCantBeEmpty: "Името на профила не може да бъде празно",
    profileSaved: "Профилът е запазен",
    profilingMachine: "Устройство за профилиране",
    profilingMachineShort: "Устр. за профилир.",
    programMaxExecutionTimeExceeded: "Превишено е максималното време за изпълнение на програмата",
    qty: "Кол",
    rangeOfValues: "Диапазон на стойността",
    rawMaterials: "Суров материал",
    readOnly: "Само четене",
    reCaptchaNoteP1: "Този сайт е защитен от reCAPTCHA.",
    reCaptchaNoteP2: " Google",
    registration: "Регистрация",
    registrationFailed: "Регистрацията е неуспешна, моля свържете се с техническата поддръжка",
    registrationSuccessful: "Регистрирахте се успешно. Последната стъпка е да потвърдите своя имейл адрес. За да направите това, последвайте връзката, предоставена в писмото, изпратено до вас.",
    reload: "Презареди",
    reloginAfterEMailChange: "Трябва да упълномощите отново, след като промените своя имейл адрес",
    rename: "Преименуване",
    requestBill: "Поискайте фактура",
    requiredField: "Задължително поле",
    requiredFieldIsEmpty: "Не е попълнено задължителното поле",
    requiredFieldPointer: "* показва задължително поле",
    requireValidEmail: "Моля, въведете валиден имейл адрес",
    reset: "Нулиране",
    rememberMe: "Да ме помниш",
    role: "Роля",
    rotate: "Завъртете",
    rotateAndPositioningDev: "Устройство за въртене и позициониране",
    rotateAndPositioningDevShort: "Устр. за върт. и позиц.",
    rotateLog90deg: "Завъртете трупа на 90 градуса",
    rotatePattern: "Завъртете комплекта",
    rotateToStartPosition: "Върнете се в изходна позиция",
    rotationAngle: "Ъгъл на завъртане",
    sameWidthSides: "Странични панели с еднаква дебелина",
    save: "Запазване",
    saveAs: "Запази като",
    saveGroup: "Запазете групата",
    saveInfo: "Запиша",
    savePattern: "Запазете комплекта",
    saveProfile: "Запази профил",
    saveProfilesLimitReachedMessage: "Вашият план за данни не ви позволява да запазвате повече хардуерни профили. Изтрийте старите или преминете към тарифен план с повече функции",
    saw: "трион",
    sawAxis: "Ос за рязане",
    sawdust: "Дървени стърготини",
    sawdustPriceM3: "Цената на 1 м3 дървени стърготини",
    sawingSettings: "Параметри на рязане",
    saws: "трион",
    sawSize: "Размер на триона",
    sawsThicknessByKerfHeight: "Дебелината на триона зависи от височината на разреза",
    sawWaste: "Отпадъци от трион",
    sawWidthDependOnKerf: "Дебелината на триона зависи от височината на разреза",
    scaleDownByLength: "Компресирайте по дължина",
    scanner: "Робот",
    screenshot: "Снимка",
    search: "Търсене",
    searchTopics: "Търсене на дял",
    select: "Избера",
    selectAll: "Избери всички",
    selectCuts: "Изберете секции",
    selectFile: "Изберете файл",
    selectImage: "Изберете изображение",
    send: "Изпратя",
    sendMailError: "Неуспешно изпращане на имейл за потвърждение на имейл адрес",
    sessionExpired: "Сесията изтече, Изисква се повторно упълномощаване",
    sessionIdMismatch: "Несъответствие на идентификатора на сесията. Вашите идентификационни данни Вероятно са били използвани за влизане на друг компютър. Текущата сесия приключи",
    settings: "Опция",
    settingsSaved: "Опциите са запазени",
    showArchived: "Показване на архивни",
    showCalculations: "Покажи изчисления",
    showMessage: "Показване на съобщение",
    showSizes: "Показване на размери",
    sideBoard: "Странична дъска",
    sideBoards: "Странични дъски",
    sideBoardsSawing: "Рязане на странични дъски",
    singleValue: "Единична стойност",
    site: "Сайт",
    sorting: "Сортиране",
    species: "Порода",
    speciesAlt: "Порода",
    speciesSwitch: "Превключване на породата",
    speciesSwitchRequest: "Превключването на породата ще нулира текущия комплект, наистина ли искате да продължите?",
    spruce: "Смърч",
    standards: "Стандарт",
    start: "Старт",
    started: "Стартирам",
    status: "Статус",
    step: "Стъпка",
    stop: "Стоп",
    stopped: "Спрян",
    subject: "Тема",
    submitApplication: "Кандидатствувам",
    subscription: "Абонамент",
    subscriptionAlmostExpired: "Абонаментът почти изтече. Остават дни:",
    subscriptions: "Абонамент",
    subscriptionExpired: "Абонаментът изтече",
    subscriptionExpiredDate: "Крайна дата на абонамента",
    subscriptionLevel: "Ниво на абонамент",
    /*
    subscriptionLevel1: "Ознакомительная",
    subscriptionLevel2: "Эконом",
    subscriptionLevel3: "Для средних предприятий",
    subscriptionLevel4: "Многопользовательская",
    subscriptionLevel5: "Профессиональная",
    subscriptionLevel6: "Холдинг",
    */
    subscriptionRenewal: "Подновяване на абонамента",
    subscriptionUpdated: "Опциите за абонамент са актуализирани",
    support: "Поддръжка",
    supportHint: "Можете да изпратите въпрос до техническата поддръжка, отговорът ще бъде изпратен на имейл адреса, посочен по време на регистрацията",
    symmetric: "Симетричен",
    symmetricSideBoards: "Симетрично добавяне на странични дъски",
    sysLog: "Дневник",
    tariffs: "Цена",
    tableData: "Таблични данни",
    tablesMethod: "Според таблиците ГОСТ",
    taper: "Бягство",
    tasks: "Задача",
    tasksHistory: "История на задачите",
    termsOfService: "Условия за ползване",
    test: "Тест",
    testReport: "Доклад от теста",
    temporaryLengthChange: "Временна промяна в дължината на участъка",
    thickness: "Дебелина",
    threeDLibrary: "Библиотека от 3D модели",
    threeDModels: "3D модели",
    time: "Време",
    title: "Заглавка",
    toggleCuts: "Превключване на дисплея за изрязване",
    toggleLog: "Превключване на показването на регистрационния файл",
    toggleCurvatureMode: "Превключване на режима на показване на кривина",
    topDMethod: "Горен диаметър и среден ход",
    total: "Обща сума",
    totalExecutionTime: "Крайно време за изпълнение",
    top: "Вертекс",
    tutorials: "Примери за използване",
    twoRowsAfterFrame: "След рамката 2 реда",
    type: "Тип",
    unsupportedPattern: "Неподдържана публикация",
    unsupportedPatternInfo: "В текущата версия на приложението търсенето на оптимален диаметър се поддържа само за прости комплекти, които не съдържат нарязани странични или централни дъски",
    unsupportedPatternInfoInEditDialog: "В текущата версия на приложението редактирането се поддържа само за прости публикации, които не съдържат изрязани странични или централни дъски",
    uploadModelsLimitReachedMessage: "Вашият план не ви позволява да изтегляте повече модели. Изтрийте старите или преминете към тарифен план с повече функции",
    uploadPatternsLimitReachedMessage: "Вашият план не ви позволява да изтегляте повече доставки. Изтрийте старите или преминете към тарифен план с повече функции",
    user: "Потребител",
    userAlreadyExists: "Потребител с този имейл адрес вече е регистриран, ако сте забравили паролата си, моля, задайте я отново или се свържете с вашия системен администратор, за да я промени",
    userCreated: "Създаден потребителски акаунт",
    userDelete: "Изтриване на акаунт",
    userInterface: "Потребителски интерфейс",
    userRegistered: "Вашият акаунт е създаден и ви е изпратен имейл с връзка за активирането му.",
    users: "Потребители",
    userUpdated: "Потребителските данни са актуализирани",
    usingWane: "Изчисляване, като се вземе предвид допустимото отклонение",
    validThrough: "Валидно до",
    valueAlreadyExists: "Стойността вече съществува",
    valueCantBeEmpty: "Стойността не може да бъде празна",
    volume: "Обем",
    volumeCalculationMethod: "Метод за изчисляване на обема",
    volumeCalculationMethods: "Методи за изчисляване на обемите",
    volumeCalculationStandard: "Таблица със стандарти",
    volumeCalculationStandards: "Стандартни таблици",
    wane: "Обзол",
    wanelessCentralBoards: "Безвредни централни дъски",
    waneWidth: "Ширина на спада",
    warning: "Внимание",
    width: "Ширина",
    woodChips: "Дървени стърготини",
    woodChipsPriceM3: "Стоимость 1 м3 щепы",
    yes: "Да",

    youSearchFor: "Според вашето искане \"",
    foundNoResults: "\" нищо не е намерено"
}

export default messages;
